@let sidebarCollapsed$ = isSidebarCollapsed();

<mat-sidenav-container
  class="h-screen"
  autosize
  [ngClass]="sidebarCollapsed$ ? 'compact-sidebar' : ''"
>
  @if (isLoggedInUser) {
    <mat-sidenav
      #sidenav
      fixedInViewport
      [mode]="isMobile() ? 'over' : 'side'"
      [opened]="isMobile() ? false : true"
      [disableClose]="!isMobile()"
      class="app-main-sidenav overflow-hidden border-r! border-[var(--sidebarBorder)] !bg-[#131a2a] dark:border-neutral-800"
    >
      <admin-sidebar
        [isCollapsed]="sidebarCollapsed$"
        (toggleSidebarEvent)="toggleSidebar()"
      ></admin-sidebar>
    </mat-sidenav>
  }

  <!-- RIGHT TASK REMINDER SIDEBAR -->
  @if (isLoggedInUser && isTaskData) {
    <!-- <mat-sidenav
      #taskSidenav
      position="end"
      [mode]="isMobile() ? 'over' : 'side'"
      [opened]="isTaskData"
      [disableClose]="true"
      class="app-task-reminder-popup h-full overflow-hidden border-r! border-l border-[var(--sidebarBorder)] border-neutral-200 !bg-[#fafafa] transition-all duration-300 dark:border-neutral-800"
    >
      <app-task-reminder-details
        [taskData]="taskData"
        (isTaskData)="isTaskDataBack($event)"
        class="h-full"
      ></app-task-reminder-details>
    </mat-sidenav> -->

    <mat-sidenav
      #taskSidenav
      position="end"
      [mode]="isMobile() ? 'over' : 'side'"
      [opened]="isTaskData"
      [disableClose]="true"
      [ngClass]="{
        'collapsed-reminder': !folderHideshow,
        'expanded-reminder': folderHideshow,
      }"
      class="app-task-reminder-popup"
    >
      <app-task-reminder-details
        [taskData]="taskData"
        [folderHideshow]="folderHideshow"
        (folderHideshowChange)="onFolderHideshowChange($event)"
        (isTaskData)="isTaskDataBack($event)"
        (refreshReminders)="getTask($event)"
        (snoozeComplete)="onSnoozeComplete($event)"
      ></app-task-reminder-details>
    </mat-sidenav>
  }

  <mat-sidenav-content
    class="content-block transition-all duration-300"
    [style.margin-right.px]="rightSidebarWidth"
  >
    @if (isLoggedInUser && registrationNotice) {
      <div
        class="registration-banner"
        [class.registration-banner--warning]="registrationNotice.tone === 'warning'"
        [class.registration-banner--danger]="registrationNotice.tone === 'danger'"
        [class.registration-banner--solicitor]="UserData?.PRODUCTTYPE !== 'Barrister'"
        [class.registration-banner--barrister]="UserData?.PRODUCTTYPE === 'Barrister'"
        [style.background-color]="registrationNotice.tone === 'brand' ? selectedColore : null"
      >
        <p class="registration-banner__message">{{ UserData?.REGISTRATIONMESSAGE }}</p>
        @if (registrationNotice.actionLabel) {
          <button
            mat-raised-button
            type="button"
            class="subscribeBtn"
            [routerLink]="['system-setting/account-management/basicinfo']"
          >
            {{ registrationNotice.actionLabel }}
          </button>
        }
        @if (registrationNotice.dismissible) {
          <button
            type="button"
            class="registration-banner__close"
            (click)="CloseNotification()"
            aria-label="Dismiss notification"
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>
    }

    @if (isLoggedInUser) {
      <toolbar></toolbar>
    }

    <!-- <div class="h-[calc(100vh-56px)] overflow-auto"> -->
    <router-outlet></router-outlet>
    <!-- </div> -->

    @if (isLoggedInUser) {
      <footer class="mt-auto bg-navy-900 text-white"></footer>
    }
  </mat-sidenav-content>
</mat-sidenav-container>
